<template>
  <section class="daySection">
    <button
      type="button"
      class="dayHeader"
      :aria-expanded="isOpen ? 'true' : 'false'"
      @click="toggle"
    >
      <span class="dayCaret" :class="{ open: isOpen }">▾</span>
      <span class="dayTitle">{{ day.date | dateWithName }}</span>
    </button>

    <transition name="collapse">
      <div v-show="isOpen" class="dayBody">
        <ProgramStageCard
          v-for="(stage, idx) in day.stages"
          :key="stage.id"
          :stage="stage"
          :dayLabel="$options.filters.dateWithName(day.date)"
          :isFirst="idx === 0"
        />
      </div>
    </transition>
  </section>
</template>

<script>
import ProgramStageCard from "@/components/base/program/mainProgram/ProgramStageCard.vue";

export default {
  name: "ProgramDay",
  components: { ProgramStageCard },
  props: {
    day: { type: Object, required: true },
    defaultOpen: { type: Boolean, default: true }
  },
  data() {
    return { isOpen: this.defaultOpen };
  },
  watch: {
    day() { this.isOpen = this.defaultOpen; }
  },
  methods: {
    toggle() { this.isOpen = !this.isOpen; }
  }
};
</script>

<style scoped>
.daySection { margin-bottom: 2.2rem; }

.dayHeader {
  width: 100%;
  text-align: left;

  background: #eae7d6;
  border: 2px solid #000;
  box-shadow: 0 8px 16px rgba(0,0,0,0.22);

  padding: 18px 22px;

  display: flex;
  align-items: center;
  gap: 12px;

  margin-bottom: 0;

  cursor: pointer;
  appearance: none;
  outline: none;

  color: #000;
  -webkit-tap-highlight-color: transparent;
}

.dayHeader:focus,
.dayHeader:focus-visible,
.dayHeader:active {
  outline: none !important;
  color: #000 !important;
  box-shadow: 0 8px 16px rgba(0,0,0,0.22) !important;
}

.dayCaret {
  font-size: 20px;
  line-height: 1;
  display: inline-block;
  transition: transform 180ms ease;
  color: #000;
}

.dayCaret.open { transform: rotate(180deg); }

/* DESKTOP: Název dne – Mono Bold 24 */
.dayTitle {
  font-family: "Transcript Pro Mono Regular";
  font-weight: 700;
  font-size: 24px;
  line-height: 1.1;
  color: #000;
}

/* collapse */
.dayBody { margin-top: 0; padding-top: 0; }
.collapse-enter-active,
.collapse-leave-active { transition: max-height 220ms ease, opacity 180ms ease; overflow: hidden; }
.collapse-enter,
.collapse-leave-to { max-height: 0; opacity: 0; }
.collapse-enter-to,
.collapse-leave { max-height: 5000px; opacity: 1; }

/* MOBILE: Název dne – 20 */
@media (max-width: 768px) {
  .dayTitle { font-size: 20px; }
}
</style>
